import './placeholder.scss';
import React, { Component } from 'react';
import Translator from './../../requests/apa/Translator';

class Placeholder extends Component {
    componentDidMount() {
        window.SpatialNavigation.makeFocusable();
    }

    render() {
        let ph_txt;
        const { type } = this.props;
        if (type === 'playlist') {
            ph_txt = Translator.get(
                'CLICK_ICON_MARK_MESSAGE',
                'Haz clic en el ícono en forma de listón dentro de una lista.'
            );
        } else if (type === 'song') {
            ph_txt = Translator.get(
                'FAVORITE_ICON_MESSAGE',
                'Haz clic en el ícono en forma de corazón dentro en una canción.'
            );
        } else if (type === 'artist') {
            ph_txt = Translator.get(
                'CLICK_ICON_HEART_ARTIST_MESSAGE',
                'Haz clic en el ícono en forma de corazón dentro de un detalle de artista.'
            );
        } else if (type === 'album') {
            ph_txt = Translator.get(
                'CLICK_ICON_HEART_MESSAGE',
                'Haz clic en el ícono en forma de corazón dentro de un albúm.'
            );
        } else if (type === 'userPlaylist') {
            ph_txt = Translator.get('CREATE_LIST_MESSAGE', 'Aún no has creado listas');
        } else if (type === 'artistRadiosLive') {
            ph_txt = Translator.get(
                'BUSQUEDA_RESULT_EMPTY',
                'Por el momento no encontramos estaciones con el artista seleccionado. Intenta con otro artista.'
            );
        } else if (type === 'artistRadiosList') {
            ph_txt = Translator.get(
                'BUSQUEDA_RESULT_EMPTY',
                'Por el momento no encontramos estaciones con el artista seleccionado. Intenta con otro artista.'
            );
        } else if (type === 'similarArtist') {
            ph_txt = Translator.get(
                'ARTIST_SIMILAR_EMPTY',
                'Por el momento no encontramos artistas similares. Intenta con otro artista.'
            );
        } else if (type === 'radiosSection') {
            ph_txt = Translator.get(
                'PLAYER_ERROR_MESSAGE_RADIO',
                'Por el momento no encontramos estaciones con el artista seleccionado. Intenta con otro artista.'
            );
        } else if (type === 'playlistsRecommended' || type === 'playlistsFree') {
            ph_txt = Translator.get(
                'BUSQUEDA_RESULT_EMPTY',
                'Por el momento no encontramos playlists. Inténtalo nuevamente.'
            );
        } else if (type === 'Forbidden') {
            ph_txt = Translator.get(
                'PLAYLIST_FORBIDEEN',
                'No puedes visualizar esta playlist porque es privada'
            );
        } else {
            ph_txt = Translator.get(
                'BUSQUEDA_RESULT_EMPTY',
                'Por el momento no encontramos lo que buscas. Inténtalo nuevamente.'
            );
        }
        return (
            <div className="ph_container">
                <div className="ph_text">{ph_txt}</div>
            </div>
        );
    }
}

export default Placeholder;



// WEBPACK FOOTER //
// ./src/containers/Placeholder/index.jsx